import { TextInput } from '@uplift/ui-v2';
import { useSectionStyles } from '../styles';
import { SectionContainerContent } from '../../components';
import { Form } from 'formik';

export const AdditionalNotes = () => {
  const { classes } = useSectionStyles();

  return (
    <SectionContainerContent>
      <Form className={classes.formGroup}>
        <TextInput
          color="secondary"
          name="additionalDetails"
          multiline
          rows={5}
          className={classes.inputBackgroundWhite}
          fullWidth
        />
      </Form>
    </SectionContainerContent>
  );
};
